export default __webpack_public_path__ + "static/media/martinize_go_3.8f2cc925.png";